import axios from "axios";
import { businessAccountBaseUrl } from "../app.config";
const apiClient = axios.create({
  baseURL: businessAccountBaseUrl,
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});
// https://cors-anywhere.herokuapp.com

export default {
  callCreateCbankApi(payload) {
    // console.log("Service Payload ==>>", payload)
    return apiClient.post("createUser", payload);
  },
  
};
